import { actions } from '../../context';
import { Link } from 'react-router-dom';
import {
    faTasks,
    faSignOutAlt,
    faTools,
} from '@fortawesome/free-solid-svg-icons';
import { DropdownItem, DropdownMenu, Badge } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import hasPermission from '../Shared/hasPermission';

function UserDropdownMenu(props) {

    const { isAuthenticated, login } = props;
    const dispatch = useDispatch();
    const updateCount = useSelector((state) => state.meta.updateCount);
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canSeeAdmin = hasPermission(['ViewAllPractices', 'Dashboard'], permissions);

    const logClick = async () => {
        await dispatch(actions.users.sessionLogout());
    };

    return (
        <DropdownMenu right>
            <DropdownItem
                onClick={() =>
                    dispatch(actions.toggle.toggleUpdateNotesModal(true))
                }>
                <FontAwesomeIcon className="text-secondary" icon={faTasks} />
                &emsp;Update Log
                {updateCount > 0 && (
                    <span>
                        &emsp;<Badge color="danger">{updateCount}</Badge>
                    </span>
                )}
            </DropdownItem>
            {canSeeAdmin && (
                    <Link
                        to="/admin"
                        className="text-dark"
                        style={{ textDecoration: 'none' }}>
                        <DropdownItem>
                            <FontAwesomeIcon
                                className="text-secondary"
                                icon={faTools}
                            />
                            &emsp;Settings
                        </DropdownItem>
                    </Link>
                )}
            <DropdownItem divider />
            <DropdownItem
                className='mt-2'
                onClick={() => (isAuthenticated ? logClick() : login())}>
                {isAuthenticated ? (
                    <>
                        <FontAwesomeIcon
                            className="text-secondary"
                            icon={faSignOutAlt}
                        />
                        &emsp;Logout
                    </>
                ) : (
                    'Login'
                )}
            </DropdownItem>
        </DropdownMenu>
    );
}

export default UserDropdownMenu;
